// .../shared/production/refiner-production-notifications.ts

import { localeNumberWithFixed } from 'psims/lib/formatters/numbers';
import { NotificationPart } from '../../../shared/notification-message';
import { ValidationResult } from './refiner-production-validation';

export function getNotificationMessage(
  onTargetClick: () => any,
  productName: string,
  validationResult: ValidationResult | null
): Array<NotificationPart> | undefined {
  if (validationResult == null) return undefined;

  const btn: NotificationPart = {
    label: 'Go to total annual volume field',
    onClick: onTargetClick,
    text: 'total annual volume',
  };

  const parts: Array<NotificationPart> = [`For ${productName}: `];

  switch (validationResult.code) {
    case 'invalid_required':
      parts.push('a value for ');
      parts.push(btn);
      parts.push(' is required.');
      break;
    case 'invalid_integer':
    case 'invalid_integer_range':
      parts.push('the value in ');
      parts.push(btn);
      parts.push(
        ` must be a positive integer (zero is permitted) with a maximum value of ${localeNumberWithFixed(validationResult.max)}.`
      );
      break;
  }

  return parts;
}